import queryString from 'query-string';

/*export const urlify = text => {
    if (!text) {
        return text;
    }

    if (typeof text !== "string") {
        throw new Error("O tipo do parâmetro text deve ser string, recebido " + typeof text + ".");
    }

    // Este "<" na expressão regular não funciona no Firefox.
    var urlRegex = /(https?:\/\/[^\s]+)(?<!(\.)|(\´)|(\,)|(\;))/g;

    return text.replace(urlRegex, url => {
        return '<a href="' + url + '" target="_blank">' + url + '</a>';
    });
};*/

export const getUniqueObjectArrayById = (arr, key = 'id') => {
    if (typeof arr !== "object") {
        throw new Error("O tipo do parâmetro arr deve ser object, recebido " + typeof arrArg + ".");
    }

    const map = new Map();

    arr.map(el => {
        if (!map.has(el[key])) {
            map.set(el[key], el);
        }
    });

    return [...map.values()];
};

export const getObjectAsURLParameterMap = source => {
    if (typeof source !== "object") {
        throw new Error("O tipo do parâmetro source deve ser object, recebido " + typeof arrArg + ".");
    }

    return JSON.stringify(source);
};

export const removeSpecialCharacter = str => {
    if (!str) {
        return str;
    }

    if (typeof str !== "string") {
        throw new Error("O tipo do parâmetro str deve ser string, recebido " + typeof str + ".");
    }

    const special = "ÀÁÂÃÄÅÆÇÈÉÊËÌÍÎÏÐÑÒÓÔÕÖØÙÚÛÜÝŔÞßàáâãäåæçèéêëìíîïðñòóôõöøùúûüýþÿŕ";
    const noSpecial = "AAAAAAACEEEEIIIIDNOOOOOOUUUUYRsBaaaaaaaceeeeiiiionoooooouuuuybyr";

    let newValue = "";

    for (let i = 0; i < str.length; i++) {
        let flag = false;

        for (let a = 0; a < special.length; a++) {
            if (str.substr(i, 1) == special.substr(a, 1)) {
                newValue += noSpecial.substr(a, 1);

                flag = true;

                break;
            }
        }

        if (!flag) {
            newValue += str.substr(i, 1);
        }
    }

    return newValue;
};

export const replaceTextToBold = (text, sub) => {
    if (!text) {
        return text;
    }

    if (typeof text !== "string") {
        throw new Error("O tipo do parâmetro text deve ser string, recebido " + typeof text + ".");
    }

    if (sub !== null && typeof sub !== "undefined" && typeof sub !== "string") {
        throw new Error("O tipo do parâmetro sub deve ser string, recebido " + typeof sub + ".");
    }

    if (sub !== '') {
        const regEx = new RegExp(sub, 'ig');

        return text.replace(regEx, (match, offset, string) => {
            return '<b>' + match + '</b>';
        });
    }

    return text;
};

export const commaSeparate = (textArray = []) => {
    let finalText = '';

    for (let i = 0; i < textArray.length; i++) {
        const text = textArray[i];

        if (i === textArray.length - 1) {
            finalText += text;
        } else {
            finalText += text + ', ';
        }
    }

    return finalText;
};

export const isInvalidDate = (dateString, numberValidDays) => {
    if (typeof dateString !== "string") {
        throw new Error("O tipo do parâmetro dateString deve ser string, recebido " + typeof dateString + ".");
    }

    if (!numberValidDays) {
        return false;
    }

    const day = dateString.substr(0, 2);
    const month = dateString.substr(3, 2);
    const year = dateString.substr(6, 4);
    const hour = dateString.substr(11);

    let dateParameter = new Date(month + "/" + day + "/" + year + " " + hour);
    dateParameter.setDate(dateParameter.getDate() + numberValidDays);

    const dateToday = new Date();

    return dateToday > dateParameter;
};

export const truncate = (input, lenght = 45) => {
    if (input.length > lenght)
        return input.substring(0, lenght) + '...';
    else
        return input;
};

export const isIOS = () => {
    return process.browser && /iPad|iPhone|iPod/.test(navigator.userAgent);
};

export const toDate = dateStr => {
    const parts = dateStr.split('/');

    return new Date(parts[2], parts[1] - 1, parts[0]);
};

export const toHour = hourStr => {
    const parts = hourStr.split(':');

    const date = new Date();
    date.setHours(parts[0]);
    date.setMinutes(parts[1]);

    return date;
};

export const toDateWithHour = dateStr => {
    if (dateStr && dateStr !== '-') {
        const parts = dateStr.trim().split(' ');

        const part1 = parts[0].split('/');
        const part2 = parts[1].split(':');

        return new Date(part1[2], part1[1] - 1, part1[0], part2[0], part2[1]);
    } else {
        return new Date();
    }
};

export const formatDate = (date = new Date()) => {
    const day = date.getDate();
    const monthIndex = date.getMonth();
    const year = date.getFullYear();

    return day.toString().padStart(2, '0') + '/' + (monthIndex + 1).toString().padStart(2, '0') + '/' + year;
};

export const formatDateHour = (data = new Date()) => {
    try {
        // Verifica se a data é válida
        if (!(data instanceof Date) || isNaN(data)) {
            throw new Error("Data inválida");
        }

        const dia = String(data.getDate()).padStart(2, '0');
        const mes = String(data.getMonth() + 1).padStart(2, '0'); // Adiciona 1 porque os meses são baseados em zero
        const ano = data.getFullYear();

        const horas = String(data.getHours()).padStart(2, '0');
        const minutos = String(data.getMinutes()).padStart(2, '0');

        return `${dia}/${mes}/${ano} ${horas}:${minutos}`;
    } catch (error) {
        console.error("Erro em formatDateHour:", error);
        return "Erro ao formatar a data";
    }
};

// Passar a DATA DEFAULT
// EX: 25/12/2012 - DD/MM/YYYY
export const convertToDate = (dateString) => {
    let d = dateString.split("/");
    return new Date(d[2] + '/' + d[1] + '/' + d[0]);
}

export const formatHour = (date = new Date()) => {
    const hours = date.getHours();
    const minutes = date.getMinutes();

    return hours.toString().padStart(2, '0') + ':' + minutes.toString().padStart(2, '0');
};

export const getCurrentYear = () => {
    return new Date().getFullYear();
};

export const normalize = (value, min, max) => (value - min) * 100 / (max - min);

export const createUrlParamsIds = ids => {
    const params = new URLSearchParams();

    ids.map(id => params.append('id', id));

    return params.toString();
};

export const downloadFile = (url, fileName = 'download') => {
    const a = document.createElement("a");

    document.body.appendChild(a);

    a.style.display = 'none';
    a.href = url;
    a.setAttribute('download',fileName);

    a.click();
};

export const getBrowserInfo = () => {
    let ua = navigator.userAgent, tem, M = ua.match(/(edge|opera|chrome|safari|firefox|msie|trident(?=\/))\/?\s*(\d+)/i)	|| [];

    if (/trident/i.test(M[1])) {
        tem = /\brv[ :]+(\d+)/g.exec(ua) || [];

        return {
            name : 'IE',
            version : (tem[1] || '')
        };
    }

    if (M[1] === 'Chrome') {
        tem = ua.match(/\bOPR\/(\d+)/);

        if (tem != null) {
            return {
                name : 'Opera',
                version : tem[1]
            };
        }

        tem = ua.match(/\bEdge\/(\d+)/);

        if (tem != null) {
            return {
                name : 'Edge',
                version : tem[1]
            };
        }
    }

    M = M[2] ? [ M[1], M[2] ] : [ navigator.appName, navigator.appVersion, '-?' ];

    if ((tem = ua.match(/version\/(\d+)/i)) != null) {
        M.splice(1, 1, tem[1]);
    }

    return {
        name : M[0],
        version : M[1]
    };
};

export const queryStringParsed = (decode = false) => {
    return queryString.parse(location.search, { decode });
};

export const formatByteValue = bytes => {
    if (bytes > 1024 * 1024 * 1024) {
        return Math.round(bytes / (1024 * 1024 * 1024)) + 'GB';
    }

    if (bytes > 1024 * 1024) {
        return Math.round(bytes / (1024 * 1024)) + 'MB';
    }

    if (bytes > 1024) {
        return Math.round(bytes / 1024) + 'KB';
    }

    return bytes + 'B';
};

export const padNumber = (num, size) => {
    num = num.toString();

    while (num.length < size) num = "0" + num;

    return num;
};

export const removeSpecialCharacter2 = palavra => {
    var caractereEspeciais = '-_.';

    for (let l in palavra){
        for (let l2 in caractereEspeciais){
            if (palavra[l] == caractereEspeciais[l2]){
                palavra = palavra.replace(palavra[l], "");
            }
        }
    }

    return palavra;
};

export const validateCPF = strCPF => {
    if (strCPF.indexOf(".") > -1 || strCPF.indexOf("-") > -1) {
        strCPF = removeSpecialCharacter2(strCPF);
    }

    let Soma;
    let Resto;

    Soma = 0;

    if (strCPF == "00000000000"
        || strCPF == "11111111111"
        || strCPF == "22222222222"
        || strCPF == "33333333333"
        || strCPF == "44444444444"
        || strCPF == "55555555555"
        || strCPF == "66666666666"
        || strCPF == "77777777777"
        || strCPF == "88888888888"
        || strCPF == "99999999999")
        return false;

    if (strCPF.length < 11) {
        strCPF = "0" + strCPF;
    }

    for (let i = 1; i <= 9; i++)
        Soma = Soma + parseInt(strCPF.substring(i-1, i)) * (11 - i);

    Resto = (Soma * 10) % 11;

    if ((Resto == 10) || (Resto == 11))
        Resto = 0;

    if (Resto != parseInt(strCPF.substring(9, 10)) )
        return false;

    Soma = 0;

    for (let i = 1; i <= 10; i++)
        Soma = Soma + parseInt(strCPF.substring(i - 1, i)) * (12 - i);

    Resto = (Soma * 10) % 11;

    if ((Resto == 10) || (Resto == 11))
        Resto = 0;

    if (Resto != parseInt(strCPF.substring(10, 11)))
        return false;

    return true;
};

export const validateCNPJ = cnpj => {
    cnpj = cnpj.replace(/[^\d]+/g,'');

    if(cnpj == '') return false;

    if (cnpj.length != 14)
        return false;

    // Elimina CNPJs invalidos conhecidos
    if (cnpj == "00000000000000" ||
        cnpj == "11111111111111" ||
        cnpj == "22222222222222" ||
        cnpj == "33333333333333" ||
        cnpj == "44444444444444" ||
        cnpj == "55555555555555" ||
        cnpj == "66666666666666" ||
        cnpj == "77777777777777" ||
        cnpj == "88888888888888" ||
        cnpj == "99999999999999")
        return false;

    // Valida DVs
    let tamanho = cnpj.length - 2
    let numeros = cnpj.substring(0,tamanho);
    let digitos = cnpj.substring(tamanho);
    let soma = 0;
    let pos = tamanho - 7;

    for (let i = tamanho; i >= 1; i--) {
        soma += numeros.charAt(tamanho - i) * pos--;
        if (pos < 2)
            pos = 9;
    }

    let resultado = soma % 11 < 2 ? 0 : 11 - soma % 11;

    if (resultado != digitos.charAt(0))
        return false;

    tamanho = tamanho + 1;
    numeros = cnpj.substring(0,tamanho);
    soma = 0;
    pos = tamanho - 7;

    for (let i = tamanho; i >= 1; i--) {
        soma += numeros.charAt(tamanho - i) * pos--;
        if (pos < 2)
            pos = 9;
    }

    resultado = soma % 11 < 2 ? 0 : 11 - soma % 11;

    if (resultado != digitos.charAt(1))
        return false;

    return true;
};

export const validateEmail = email => {
    let usuario = email.substring(0, email.indexOf("@"));
    let dominio = email.substring(email.indexOf("@") + 1, email.length);

    if ((usuario.length >= 1) && (dominio.length >= 3) && (usuario.search("@") == -1)
        && (dominio.search("@") == -1) && (usuario.search(" ") == -1)
        && (dominio.search(" ") == -1) && (dominio.search(".") != -1)
        && (dominio.indexOf(".") >= 1) && (dominio.lastIndexOf(".") < dominio.length - 1)) {
        return true;
    } else {
        return false;
    }
};

export const calculateAge = dataNascimento => {
    let birthMonth = dataNascimento.substring(3, 5);
    let birthDay = dataNascimento.substring(0, 2);
    let birthYear = dataNascimento.substring(6, 10);
    let todayDate = new Date();
    let todayYear = todayDate.getFullYear();
    let todayMonth = todayDate.getMonth();
    let todayDay = todayDate.getDate();

    let age = todayYear - birthYear;

    if (todayMonth < birthMonth - 1){
        age--;
    }

    if (birthMonth - 1 === todayMonth && todayDay < birthDay) {
        age--;
    }

    return age;
};

export const dateInFull = () => {
    const meses = new Array("Janeiro","Fevereiro","Março","Abril","Maio","Junho","Julho","Agosto","Setembro","Outubro","Novembro","Dezembro");
    const semana = new Array("Domingo","Segunda-feira","Terça-feira","Quarta-feira","Quinta-feira","Sexta-feira","Sábado");

    const hoje = new Date();
    const dia = hoje.getDate();
    const mes = hoje.getMonth();
    let ano = hoje.getYear();

    if (navigator.appName === "Netscape") {
        ano = ano + 1900;
    }

    return dia + " de " + meses[mes] + " de " + ano;
};

export const formatCurrency = number => {
    return new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(number);
};

export const fillFormikFields = (formik, object) => {
    Object.entries(object).map(([key, value]) => {
        formik.setFieldValue(key, value, false);
    });
}

export const fillReactHookFormFields = (setValue, object) => {
    Object.entries(object).map(([key, value]) => {
        setValue(key, value);
    });
}

// Função que converte a data no formato "dd/mm/yyyy" para "yyyy-mm-dd"
const converterParaFormatoISO = (dataString) => {
    const [dia, mes, ano] = dataString.split('/');

    // Adiciona um zero à esquerda para o mês e o dia, se necessário
    const mesFormatado = mes.padStart(2, '0');
    const diaFormatado = dia.padStart(2, '0');

    // Formata a data no formato "yyyy-mm-dd"
    const dataFormatada = `${ano}-${mesFormatado}-${diaFormatado}`;

    return dataFormatada;
};

// Função que verifica se a data está entre dataInicial e dataFinal
export const dataEstaEntre = (data, dataInicial, dataFinal) => {
    const dataTeste = new Date(data);
    const dataIni = new Date(converterParaFormatoISO(dataInicial));
    const dataFim = new Date(converterParaFormatoISO(dataFinal));

    return dataTeste >= dataIni && dataTeste <= dataFim;
};

// Função que verifica se o que o usuário digitou é um número
export const numericOnly = (e) => {
    if (
        !/[0-9]/.test(e.key) &&
        e.key !== "Backspace" &&
        e.key !== "Delete" &&
        e.key !== "Enter"
    ) {
        e.preventDefault();
    }
};

export const capitalizeFirstLetter = (string) => {
    return string.charAt(0).toUpperCase() + string.slice(1);
};

export const compareDates = (data1, data2, flag) => {
    var data1Obj = new Date(data1);
    var data2Obj = new Date(data2);

    if (flag === 'menor') {
        return data1Obj < data2Obj;
    } else if (flag === 'maior') {
        return data1Obj > data2Obj;
    } else {
        throw new Error("Flag inválida. Use 'menor' ou 'maior'.");
    }
}

export const formatCpfMasked = (cpf) => {
    if (!cpf) return '';
    const clean = cpf.replace(/\D/g, '');
    if (clean.length === 11) {
        return `***.***.${clean.substring(6, 9)}-${clean.substring(9, 11)}`;
    }
    return cpf;
};

const SITUACOES_INSCRICAO = {
    C: 'Classificado',
    D: 'Desclassificado',
    S: 'Selecionado',
    A: 'Em análise',
    P: 'Com pendência',
    H: 'Habilitado',
    I: 'Inabilitado',
    N: 'Sem informação'
};

export const getSituacaoInscricao = (codigo) => {
    const normalizedCode = codigo === null || codigo === undefined
        ? ''
        : String(codigo).trim().toUpperCase();

    return SITUACOES_INSCRICAO[normalizedCode] || 'Sem informação';
};

export const getPendenciasInscricao = (identificacao) => {
    const pendencias = identificacao?.inscricaoPendenciaAnexos;
    return Array.isArray(pendencias) ? pendencias : [];
};

export const formatDateDisplay = (dateValue) => {
    if (!dateValue) return '';

    if (typeof dateValue === 'string') {
        const value = dateValue.trim();
        if (/^\d{2}\/\d{2}\/\d{4}/.test(value)) {
            return value.substring(0, 10);
        }

        const isoMatch = value.match(/^(\d{4})-(\d{2})-(\d{2})/);
        if (isoMatch) {
            return `${isoMatch[3]}/${isoMatch[2]}/${isoMatch[1]}`;
        }
    }

    const parsedDate = new Date(dateValue);
    if (Number.isNaN(parsedDate.getTime())) return '';

    return formatDate(parsedDate);
};

// Converte data no formato brasileiro "DD/MM/YYYY" para ISO "YYYY-MM-DD"
export const convertBrDateToISO = (dateString) => {
    if (!dateString) return null;
    const parts = dateString.split('/');
    if (parts.length !== 3) return null;
    const [dia, mes, ano] = parts;
    return `${ano}-${mes.padStart(2, '0')}-${dia.padStart(2, '0')}`;
};

// Converte string decimal no formato brasileiro (ex: "1.234,56") para número
export const parseDecimal = (value) => {
    if (value === null || value === undefined || value === '') return null;
    if (typeof value === 'number') return value;
    const cleaned = String(value).replace(/\./g, '').replace(',', '.');
    const parsed = parseFloat(cleaned);
    return isNaN(parsed) ? null : parsed;
};

// Campo de dinheiro estilo banco: os dígitos preenchem a partir dos centavos (5 → 0,05; 5000 → 50,00).
export const MAX_DIGITOS_VALOR_MONETARIO = 13;

export const valorParaCentavos = (valor) => {
    const numero = parseDecimal(valor);
    return numero === null ? null : Math.round(numero * 100);
};

export const formatarCentavos = (centavos) => (centavos === null || centavos === undefined)
    ? ''
    : (centavos / 100).toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 });

// Recebe o texto do input depois da tecla e o valor atual; devolve o novo valor em reais (número) ou ''.
export const proximoValorMonetario = (textoDigitado, valorAtual) => {
    const digitos = String(textoDigitado ?? '').replace(/\D/g, '');
    if (digitos === '') return '';
    const centavos = parseInt(digitos, 10);
    if (String(centavos).length > MAX_DIGITOS_VALOR_MONETARIO) return valorAtual;
    // Apagar a partir de "0,00" limpa o campo, em vez de travar no zero.
    const textoAtual = formatarCentavos(valorParaCentavos(valorAtual));
    if (centavos === 0 && String(textoDigitado).length < textoAtual.length) return '';
    return centavos / 100;
};

// Centraliza o calculo de renda para manter consistencia entre telas.
export const calcularIndicadoresRendaInscricao = (dadosCadastrais = {}) => {
    const toDecimal = (value) => parseDecimal(value) ?? 0;

    const rendas = dadosCadastrais?.rendas || dadosCadastrais?.renda || [];
    const composicaoFamiliar = dadosCadastrais?.composicaoFamiliar || [];

    const rendaCandidato = rendas.reduce((acc, renda) => acc + toDecimal(renda?.vlrRenda), 0);
    const rendaComposicao = composicaoFamiliar.reduce((acc, membro) => acc + toDecimal(membro?.rendaBruta), 0);
    const rendaFamiliarBruta = rendaCandidato + rendaComposicao;

    const rendaAgregada = toDecimal(dadosCadastrais?.vlrPensao) + toDecimal(dadosCadastrais?.vlrPensaoFilho);
    const rendaBrutaTotal = rendaFamiliarBruta + rendaAgregada;

    const totalIntegrantes = 1 + composicaoFamiliar.length;
    const rendaPerCapita = rendaBrutaTotal / (totalIntegrantes || 1);

    return {
        rendaCandidato,
        rendaComposicao,
        rendaFamiliarBruta,
        rendaAgregada,
        rendaBrutaTotal,
        totalIntegrantes,
        rendaPerCapita
    };
};

